import React from 'react';
import PropTypes from 'prop-types';
import GlobalModal from 'components/modals/GlobalModal';
import ProductFilters from 'pages/products/productRelated/ProductFilters';
import ProductListTable from './ProductListTable';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { AddIcon } from 'assets/materialIcons/materialIcons';

const ProductModal = (props) => {
    const {
        actionType,
        addLabel,
        data,
        handleAdd,
        location,
        resource,
        source,
        title,
        translate,
    } = props;

    const actions = [
        {
            label: translate('actions.goBack'),
            focus: true,
            primary: true,
        },
    ];

    return <GlobalModal
        button={ {
            icon: <AddIcon color={ theme.palette.doveGray } />,
            title: translate(addLabel),
            primary: false,
        } }
        dialog={ {
            actions: actions,
            title: translate(title),
        } }
    >
        <ProductFilters
            actionType={ actionType }
            location={ location }
            resource={ resource }
        />

        <ProductListTable
            values={ data[source] || [] }
            handleAdd={ (productId) => {
                return handleAdd(productId, source);
            } }
        />
    </GlobalModal>;
};

ProductModal.defaultProps = {
    actionType: 'PRODUCTS',
    addLabel: 'actions.add',
    resource: 'products',
    source: 'products',
    title: 'resources.products.title',
};

ProductModal.propTypes = {
    actionType: PropTypes.string,
    addLabel: PropTypes.string,
    data: PropTypes.object.isRequired,
    handleAdd: PropTypes.func.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    source: PropTypes.string.isRequired,
    title: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

export default translate(ProductModal);



// WEBPACK FOOTER //
// ./src/components/modals/product/ProductModal.js